module.exports = __webpack_public_path__ + "img/estrutura.3207d6c7.jpg";